import {MasterOfActsAPI} from "../../api/api";

const SUCCESS_LOAD_CONTRACTS = 'contractReducer/SUCCESS_LOAD_CONTRACTS'
const ERROR_LOAD_CONTRACTS = 'contractReducer/ERROR_LOAD_CONTRACTS'
const SET_SELECTED_CONTRACTS = 'contractReducer/SET_SELECTED_CONTRACTS'


const initialState = {
    contracts: [],
    selectedContract: null,
    loading: true,
    error: null
}

export const contractReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_LOAD_CONTRACTS:
            return {...state, contracts: action.contracts, loading: false, selectedContract: state.selectedContract ? state.selectedContract: action.contracts[0]}
        case ERROR_LOAD_CONTRACTS:
            return {...state, loading: false, error: 'Что-то пошло не так... Попробуйте перезагрузить страницу'}
        case SET_SELECTED_CONTRACTS:
            return {...state, selectedContract: action.selectedContract}
        default:
            return state
    }
}


export const selectContracts = state => state.contractReducer

export const successLoadContracts = (contracts) => ({type: SUCCESS_LOAD_CONTRACTS, contracts})
export const errorLoadContracts = () => ({type: ERROR_LOAD_CONTRACTS})
export const setSelectedContract = (selectedContract) => ({type: SET_SELECTED_CONTRACTS, selectedContract})


export const loadingContracts = async dispatch => {
    const response = await MasterOfActsAPI.getContracts()
    if (response.status === 200 && response.data.length !== 0) {
        dispatch(successLoadContracts(response.data))
    } else {
        dispatch(errorLoadContracts())
    }
}
